<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.categories') }} > {{ this.$route.query.cat_name }}
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="category !== null"
            class="action">
            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.category')"/>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row mb-0">
                  <div class="col-md-12">
                    <label>{{ $t('message.category_name') }} *</label>
                    <input
                      ref="category_name"
                      :placeholder="$t('placeholder.required')"
                      :disabled="disabledForm"
                      v-model="textfield.category_name"
                      type="text"
                      class="form-control category-name">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="items.length > 0"
          :class="[{ disabled: disabledForm }]"
          class="assign-items mt-3"
          style="margin-bottom: 20px;">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.assignitems') + ' ('+assignitems.length+')'"/>
            <div class="col-md-12 row align-items-center no-padding no-margin subheader-assign">
              <div class="col no-padding">{{ $t('message.productlist') }}</div>
            </div>
            <div
              v-for="(item, index) in items"
              :key="index"
              :class="{ active: item.active}"
              class="col-md-12 row align-items-center no-padding no-margin item"
              @click="toggleAssign(item)">
              <div class="col">
                {{ item.product_name }}
              </div>
              <div class="col text-right">
                <span v-if="!item.active && item.category_id != category.category_id">
                  {{ item.category_name }}
                </span>
                <span v-if="item.active">
                  {{ textfield.category_name }}
                </span>
                <i class="fas fa-check-circle"/>
                <i class="far fa-circle"/>
              </div>
            </div>
          </div>
        </section>
        <section
          v-if="!disabledForm"
          class="action-bar"
        >
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              @click="update()">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <!-- <button class="btn btn-light" disabled>{{ $t('button.cancel') }}</button> -->
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5
              v-if="category"
              class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'

export default {
  name: 'CategoryEdit',
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      textfield: {
        category_name: '',
      },
      original_textfield: null,

      items: [],
      original_items: null,

      assignitems: [],
      original_assignitems: null,

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      sidebar: 'getSidebar',
      products: 'getProducts',
      category: 'getCategory',
    }),
    form () {
      return {
        textfield: this.textfield,
        items: this.items,
        assignitems: this.assignitems,
      }
    },
    disabledForm () {
      return !this.hasRoleEdit
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    items: {
      handler: function (after) {
        let items = after
        this.updateAssignItems(items)
      },
      deep: true,
    },
    textfield: {
      handler: function (after) {
        if (after.category_name.trim().length > 0) {
          $(this.$refs.category_name).removeClass('is-invalid')
        } else {
          $(this.$refs.category_name).addClass('is-invalid')
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () { // clear states

  },
  created: async function () { // call api to get data and set state
    /**
     *  validation
     */
    if (!this.$route.query.cat_id) {
      return this.$router.push({ name: 'CategoryAll' })
    }
    // get category
    let res = await this.$store.dispatch('getCategory', {
      category_id: this.$route.query.cat_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'CategoryAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'CategoryAll' })
    }
    /**
     *  validation success
     */
    // set textfield category_name
    this.textfield.category_name = this.category.category_name
    // get products
    await this.$store.dispatch('getProducts')
    // set items
    this.setItems(this.category, this.products)
    // update assignitems
    this.updateAssignItems(this.items)
    // original textfield
    this.original_textfield = this.getObject(this.textfield)
    // original items
    this.original_items = this.getObject(this.items)
    // original assignitems
    this.original_assignitems = this.getObject(this.assignitems)
    // set ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.products.title'),
      current: {
        app_name: 'products',
        app_id: 2,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, [{
      'name': this.$route.query.cat_name,
      'router': {
        'name': 'CategoryEdit',
        'query': {
          cat_id: this.$route.query.cat_id,
          cat_name: this.$route.query.cat_name,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 1,
      submenuAtIdx: 2,
    })
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#confirmdeleteModal')
  },
  updated: function () { // re-rendered html

  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearProducts', 'clearCategory'])
  },
  methods: {
    toggleAssign (item) {
      if (this.textfield.category_name.trim().length == 0) {
        this.textfield.category_name = ''
        return $(this.$refs.category_name).focus().addClass('is-invalid')
      }
      item.active = !item.active
    },
    async update () {
      if (this.textfield.category_name.trim().length == 0) {
        return $(this.$refs.category_name).focus().addClass('is-invalid')
      }

      this.isSubmitted = true

      let data = {
        category_id: this.category.category_id,
        category_name: this.textfield.category_name,
      }

      if (this.assignitems.length > 0) {
        data['assign'] = this.assignitems
      }

      let res = await this.$store.dispatch('updateCategory', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.textfield.category_name }),
          color: 'success',
          icon: 'save',
        })
        // get products
        await this.$store.dispatch('getProducts')
        // set items
        this.setItems(this.category, this.products)
        // update assignitems
        this.updateAssignItems(this.items)
        // original textfield
        this.original_textfield = this.getObject(this.textfield)
        // original items
        this.original_items = this.getObject(this.items)
        // original assignitems
        this.original_assignitems = this.getObject(this.assignitems)
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    async del () {
      let data = {
        category_id: this.category.category_id,
      }

      let res = await this.$store.dispatch('deleteCategory', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.textfield.category_name }),
          color: 'danger',
          icon: 'delete',
        })
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsIssueAll page
        return this.$router.push({ name: 'CategoryAll' })
      }
    },
    setItems (category, products) {
      this.items = []
      for (let i in products) {
        let product = products[i]
        if (product.type == 'product') {
          var active = false
          if (category) {
            if (category.category_id == product.category_id) {
              active = true
            }
          }
          this.items.push({
            product_id: product.product_id,
            product_name: product.product_name,
            category_id: product.category_id,
            category_name: product.category_name,
            active: active,
          })
        }
      }
    },
    updateAssignItems (items) {
      this.assignitems = []
      for (let i in items) {
        let item = items[i]
        if (item.active) {
          this.assignitems.push({
            product_id: item.product_id,
          })
        }
      }
    },
    openConfirmdeleteModal () {
      // open modal
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/items/category/Edit.vue